<div class="container">
  <!-- Filter Icon Button for small screens -->
  <button mat-icon-button class="filter-icon" (click)="toggleFilterSidebar()">
    <mat-icon >filter_list</mat-icon>
  </button>

  <!-- Sidebar Filter Panel -->
  <div class="filter-sidebar" [class.open]="isFilterSidebarOpen">

    <!-- Filter Action Buttons -->
    <div class="row mb-3">
      <div class="col-7">
        <button mat-button class="font1 text-primary"
          (click)="applyFilter()">Apply Filters</button>
      </div>
      <div class="col-5 text-end">
        <button mat-button class="font1 text-primary"
          (click)="clearSelection()">Clear All</button>
      </div>
    </div>

    <div>Search a Location</div><br>
    <div class="styled-select-container12">
      <ng-select

        [items]="AreaDataList"
        bindLabel="area"
        bindValue="area"
        [(ngModel)]="searchAreaQuery"
        [placeholder]="'Search Area'"
        [compareWith]="compareAreas"
        (search)="searchArea($event.term)"
        (focus)="searchArea('')"
        (click)="onAreaInputClick()"
        (blur)="setarea()"
        (change)="selectArea($event)">
      </ng-select>

    </div>
    <br>

    <div>Budget</div><br>
    <div class="styled-select-container12">
      <ng-select
        [items]="budgetOptions"
        bindLabel="label"
        bindValue="value"
        [(ngModel)]="selectedMaxValue"
        (change)="onBudgetChange()"
        placeholder="Select Budget"
        [searchable]="false"
        [clearable]="false"
        class="w-full">
      </ng-select>
    </div><br>

    <div>Property Type</div><br>
    <mat-chip-list>
      <mat-chip *ngFor="let propertyType of propertyTypes"
        [selected]="propertyType.selected"
        (click)="selectPropertyType(propertyType)">
        <mat-icon>{{ propertyType.selected ? 'check_circle' : 'add'
          }}</mat-icon>
        <span class="font12">{{ propertyType.name }}</span>
      </mat-chip>
    </mat-chip-list>
<br>
  </div>
</div>
